import {apiAction} from './helper';

export const GET_ENERGY_RETENTION_PERIODS = apiAction('GET_ENERGY_RETENTION_PERIODS');
